import PropTypes from 'prop-types';
import { useState, useRef, useEffect } from 'react';

import { ReactComponent as CloseStrokeSVG } from 'icons/close-stroke.svg';

import { useOutsideClick } from 'helpers/clickOutside';

import Button from 'components/button';
import Checkbox from 'components/checkbox/checkbox';
import { getPatientFeeStructure } from 'api/fee_structure';

const EXAM_CHARGE_AMOUNT = 24;
const MIN_CHARGE = 0.5;

const ChargeModal = ({
  type,
  title,
  content,
  doctor,
  customer,
  onClose,
  onClickOutside,
  onCharge,
}) => {
  const [doctorFee, setDoctorFee] = useState(
    customer.patientRights ===
      'required-to-pay-for-consultations-and-examinations' ||
      !customer.patientRights
      ? EXAM_CHARGE_AMOUNT
      : 0,
  );
  const [patientFee, setPatientFee] = useState(0);

  const [doctorFeeChecked, setDoctorFeeChecked] = useState(
    customer.patientRights ===
      'required-to-pay-for-consultations-and-examinations' ||
      !customer.patientRights,
  );
  const [patientFeeStructure, setPatientFeeStructure] = useState(0);
  const [patientFeeChecked, setPatientFeeChecked] = useState(true);

  const [valid, setValid] = useState(true);
  const [loading, setLoading] = useState(false);
  const [validationText, setValidationText] = useState('');

  const ref = useRef(null);
  useOutsideClick(ref, onClickOutside);

  const handleCharge = () => {
    const total = doctorFee + patientFee;
    if (total >= MIN_CHARGE) {
      setLoading(true);
      onCharge(doctorFee, patientFee);
    } else {
      if (total >= 0 && total < MIN_CHARGE) {
        setValidationText('Amount should be more or equal to €0.5!');
      }

      setValid(false);
    }
  };

  useEffect(() => {
    async function fetchFeeStructure() {
      setLoading(true);
      const feeStructure = await getPatientFeeStructure(
        customer.id,
        doctor.id,
        type,
      );

      setPatientFeeStructure(feeStructure);
      setPatientFee(Number(feeStructure?.patientFee));
      setLoading(false);
    }
    fetchFeeStructure();
  }, []);

  return (
    <div
      className="fullscreen-modal-container"
      style={{ visibility: 'visible' }}
    >
      <div className="fullscreen-modal-background"></div>
      <div
        className="fullscreen-modal fullscreen-modal-action fullscreen-modal-wide"
        ref={ref}
      >
        <section className="modal-content">
          <header className="modal-header">
            <h1>{title}</h1>
          </header>
          <span onClick={() => onClose()} className="pointer close">
            <CloseStrokeSVG />
          </span>

          <div className="modal-body">
            <p
              className="mb6"
              dangerouslySetInnerHTML={{ __html: content }}
            ></p>
          </div>

          <div className="input-group w-100">
            <label>Amount*</label>
            {!valid && <span className="error">{validationText}</span>}
            <Checkbox
              checked={doctorFeeChecked}
              label={`€${EXAM_CHARGE_AMOUNT} to ${doctor?.lastName?.toUpperCase()} ${
                doctor?.firstName
              }`}
              onChange={() => {
                setDoctorFeeChecked(!doctorFeeChecked);
                setDoctorFee(doctorFeeChecked ? 0 : EXAM_CHARGE_AMOUNT);
              }}
            />
            <Checkbox
              checked={patientFeeChecked}
              label={`€${patientFeeStructure?.patientFee} to SleepDoctor`}
              onChange={() => {
                setPatientFeeChecked(!patientFeeChecked);
                setPatientFee(
                  patientFeeChecked
                    ? 0
                    : Number(patientFeeStructure?.patientFee),
                );
              }}
            />
          </div>

          <div className="modal-footer flex justify-end">
            <Button
              className="w-100"
              label={`Charge €${doctorFee + patientFee}`}
              color="purple"
              loading={loading}
              onClick={handleCharge}
            />
          </div>
        </section>
      </div>
    </div>
  );
};

ChargeModal.propTypes = {
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onClickOutside: PropTypes.func.isRequired,
  onCharge: PropTypes.func.isRequired,
};

export default ChargeModal;
